import gql from 'graphql-tag';
import { graphql } from 'react-apollo';

export const deleteChannelMutation = gql`
  mutation deleteChannel($channelId: ID!) {
    deleteChannel(channelId: $channelId)
  }
`;

const deleteChannelOptions = {
  props: ({ mutate }) => ({
    deleteChannel: channelId =>
      mutate({
        variables: {
          channelId,
        },
      }),
  }),
};

export default graphql(deleteChannelMutation, deleteChannelOptions);
